import { create } from 'zustand';

/**
 * Estado SÓLO de navegación del canvas: nada de esto toca el grafo ni se
 * guarda en el proyecto.
 *  - flashNodeId: nodo que parpadea 2 s después de un "llevame al nodo"
 *  - pathHighlight: interruptor de los caminos iluminados
 */
const FLASH_MS = 2000;

export const PATH_HIGHLIGHT_AVAILABLE =
  String(process.env.REACT_APP_PATH_HIGHLIGHT ?? 'true').toLowerCase() !== 'false';

export const NODE_NAMES_AVAILABLE =
  String(process.env.REACT_APP_NODE_NAMES ?? 'true').toLowerCase() !== 'false';

let flashTimer = null;

export const useCanvasNavStore = create((set) => ({
  flashNodeId: null,
  pathHighlight: PATH_HIGHLIGHT_AVAILABLE,
  searchOpen: false,
  // Pedido de centrado pendiente: lo consume el canvas cuando está montado
  // (si el usuario está en la pestaña del timeline, espera ahí).
  focusRequest: null,

  flash: (nodeId) => {
    if (flashTimer) clearTimeout(flashTimer);
    set({ flashNodeId: nodeId });
    flashTimer = setTimeout(() => set({ flashNodeId: null }), FLASH_MS);
  },

  requestFocus: (nodeId) =>
    set({ focusRequest: { nodeId, at: Date.now() } }),

  clearFocusRequest: () => set({ focusRequest: null }),

  togglePathHighlight: () =>
    set((s) => ({ pathHighlight: !s.pathHighlight })),

  setSearchOpen: (open) => set({ searchOpen: open }),
}));

export default useCanvasNavStore;
